angular.module('jv.SendMessage.Controller',[])
.controller('sendMessageController',['$scope', '$rootScope', '$routeParams', 'application',
    function($scope, $rootScope, $routeParams, application) {
        $scope.cleanModal = function() {
            $scope.sendMessageForm.$setPristine();
            $scope.submitted = false;
            $scope.subject = '';
            $scope.content = '';
        };

        $scope.sendMessage = function() {
            var content = $scope.content;
            if (content && content.length > $scope.messageLength) {
                $scope.contentLengthError = true;
                return;
            }

            if ($scope.sendMessageForm.$invalid) {
                return;
            }

            $rootScope.loading = true;
            var data = {
                'appId': $routeParams.jobId,
                'subject': $scope.subject,
                'content': $scope.content
            };
            application.sendMessage(data, function(res) {
                var response = res.data;
                $rootScope.$broadcast('messageSent', response.applicationMessage);
                $rootScope.loading = false;
                $scope.hideModal();
            }, function() {
                $scope.hideModal();
                $rootScope.loading = false;
            });
        };

        $scope.$on('hidingMessageModal', function() {
            $scope.cleanModal();
        });

        $scope.hideModal = function() {
            $rootScope.$broadcast('hidingMessageModal');
            $scope.cleanModal();
        };
    }
]);